import React from 'react';
import { useTranslation } from 'react-i18next';
import { getThemeColors } from '../../../../lib/theme';

export function ConfirmDelete({ dark, label, onConfirm, onCancel }: { dark: boolean; label: string; onConfirm: () => void; onCancel: () => void }) {
  const t = getThemeColors(dark);
  const { t: tr } = useTranslation();
  return (
    <div style={{ padding: '10px 16px', borderBottom: `1px solid ${t.border}`, background: dark ? '#1a0505' : '#fff5f5', display: 'flex', alignItems: 'center', gap: 12 }}>
      <span style={{ fontSize: 12.5, color: '#b42318', flex: 1 }}>{tr('common.confirm_delete', { item: label })}</span>
      <button onClick={onConfirm} style={{ fontSize: 12, fontWeight: 600, background: '#b42318', color: '#fff', border: 'none', borderRadius: 6, padding: '5px 12px', cursor: 'pointer' }}>
        {tr('common.action.delete')}
      </button>
      <button onClick={onCancel} style={{ fontSize: 12, background: 'none', border: `1px solid ${t.border}`, borderRadius: 6, padding: '5px 10px', color: t.muted, cursor: 'pointer' }}>
        {tr('common.action.cancel')}
      </button>
    </div>
  );
}
